import React from 'react';
import { Link } from 'gatsby';
import s from './category-pill.module.scss';
import { useCategoryColor } from '@/hooks/useCategoryColor';

export default function CategoryPill({ category, className }) {
const { sanitizedCategory, categoryColor } = useCategoryColor(category);
  return (
    <Link
      onClick={e => e.stopPropagation()}
      className={`${s.root} ${categoryColor && s[categoryColor]} ${className ||
        ''}`}
      to={`/${sanitizedCategory}`}
    >
      <span dangerouslySetInnerHTML={{ __html: category?.toLowerCase() }} />
    </Link>
  );
}
